import { forwardRef, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Eye, EyeOff } from 'lucide-react';

/**
 * PasswordInput — Input with an eye-toggle to show/hide the value.
 *
 * Props are forwarded to the underlying <Input>. Provide `data-testid` for
 * the input and it will also add `<testid>-toggle` to the button.
 */
export const PasswordInput = forwardRef(function PasswordInput(
  { className = '', 'data-testid': testId, ...props },
  ref,
) {
  const [visible, setVisible] = useState(false);
  const toggleId = testId ? `${testId}-toggle` : undefined;
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        autoComplete={props.autoComplete || 'current-password'}
        data-testid={testId}
        className={`pr-10 ${className}`}
        {...props}
      />
      <button
        type="button"
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-slate-400 hover:text-slate-700 focus:outline-none focus-visible:text-slate-900"
        tabIndex={-1}
        data-testid={toggleId}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
